import React from 'react';
import Button from 'react-bootstrap/Button';

class GoogleScholarSearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '', // Initialize the state for the search query
    };
  }

  handleInputChange = (event) => {
    this.setState({ searchText: event.target.value }); // Update the state when input changes
  };

  render() {
    return (
      <form
        id="scholarbounce"
        action="https://scholar.google.com/scholar"
        method="get"
        name="q"
        target="_blank"
      >
        <div className='input-group'>
          <input
            type="text"
            name="q"
            className="form-control"
            value={this.state.searchQuery} // Bind input value to state
            onChange={this.handleInputChange} // Handle input change
            placeholder="Type book name, author or ID"
          />
          <Button 
          type="submit"
          name="submit"
          value="Submit"
          className="btn btn-outline-secondary"
          >
              <img src='/assets/img/search-icon.svg' alt=""/> 
          </Button>
        </div>
      </form>
    );
  }
}

export default GoogleScholarSearchForm;
